import React from 'react';
import { Pie, Bar } from 'react-chartjs-2';
import { Grid, Card } from '@mui/material';

const InsightsDashboard = ({ candidates }) => {
  // Extracting data for insights
  const ages = candidates.map(candidate => candidate.age);
  const genderCounts = candidates.reduce((counts, candidate) => {
    const { gender } = candidate;
    if (gender === "male" || gender === "female" || gender === "") {
      counts[gender] = (counts[gender] || 0) + 1;
    }
    return counts;
  }, {});
  

  const civilStatusCounts = candidates.reduce((counts, candidate) => {
    counts[candidate.civilStatus] = (counts[candidate.civilStatus] || 0) + 1;
    return counts;
  }, {});
  const availabilityCounts = candidates.reduce((counts, candidate) => {
    counts[candidate.availability] = (counts[candidate.availability] || 0) + 1;
    return counts;
  }, {});
  const appliedPositionCounts = candidates.reduce((counts, candidate) => {
    counts[candidate?.personalInfo?.appliedPosition] =
      (counts[candidate?.personalInfo?.appliedPosition] || 0) + 1;
    return counts;
  }, {});

  //push it
  
  // Data for charts
  const ageData = {
    labels: ['18-24', '25-34', '35-44', '45+'],
    datasets: [
      {
        data: [
          ages.filter(age => age >= 18 && age <= 24).length,
          ages.filter(age => age >= 25 && age <= 34).length,
          ages.filter(age => age >= 35 && age <= 44).length,
          ages.filter(age => age >= 45).length,
        ],
        backgroundColor: ['#FF6384', '#36A2EB', '#FFCE56', '#4BC0C0'],
      },
    ],
  };

  const genderData = {
    labels: Object.keys(genderCounts),
    datasets: [
      {
        data: Object.values(genderCounts),
        backgroundColor: ['#FF6384', '#36A2EB', '#FFCE56'],
      },
    ],
  };

  const civilStatusData = {
    labels: Object.keys(civilStatusCounts),
    datasets: [
      {
        data: Object.values(civilStatusCounts),
        backgroundColor: ['#FF6384', '#36A2EB', '#FFCE56'],
      },
    ],
  };

  const availabilityData = {
    labels: Object.keys(availabilityCounts),
    datasets: [
      {
        label: 'Count',
        data: Object.values(availabilityCounts),
        backgroundColor: '#FF6384',
      },
    ],
  };

  const appliedPositionData = {
    labels: Object.keys(appliedPositionCounts),
    datasets: [
      {
        label: 'Count',
        data: Object.values(appliedPositionCounts),
        backgroundColor: '#FF6384',
      },
    ],
  };

  return (
    <div>
     <Grid container spacing={3}>
      <Grid item xs={4}>
      <Card style={{ background: 'rgba(255, 255, 255, 0.4)', boxShadow: '0 2px 4px rgba(0, 0, 0, 0.2)' }}>
            <div style={{ textAlign: 'center' }}>
      <div>
        <h3>Age Range</h3>
        <Pie data={ageData} />
      </div>
      </div>
      </Card>
      </Grid>
    <Grid item xs={4}>
    <Card style={{ background: 'rgba(255, 255, 255, 0.4)', boxShadow: '0 2px 4px rgba(0, 0, 0, 0.2)' }}>
            <div style={{ textAlign: 'center' }}>
      <div>
        <h3>Gender</h3>
        <Pie data={genderData} />
      </div>
    </div>
    </Card>
    </Grid>
    <Grid item xs={4}>
    <Card style={{ background: 'rgba(255, 255, 255, 0.4)', boxShadow: '0 2px 4px rgba(0, 0, 0, 0.2)' }}>
            <div style={{ textAlign: 'center' }}>
      <div>
    
        <h3>Civil Status</h3>
        <Pie data={civilStatusData} />
      </div>
      </div>
      </Card>
    </Grid>
    <Grid item xs={12}>
    <Card style={{ background: 'rgba(255, 255, 255, 0.4)', boxShadow: '0 2px 4px rgba(0, 0, 0, 0.2)' }}>
            <div style={{ textAlign: 'center' }}>
      <div>
        <h3>Availability</h3>
        <Bar data={availabilityData} />
      </div>
    </div>
    </Card>
    </Grid>
    <Grid item xs={12}>
    <Card style={{ background: 'rgba(255, 255, 255, 0.4)', boxShadow: '0 2px 4px rgba(0, 0, 0, 0.2)' }}>
        <div style={{ textAlign: 'center' }}>
        <div>
            <h3>Applied Positions</h3>
            <Bar data={appliedPositionData} />
        </div>
    </div>
    </Card>
      </Grid>
      </Grid>
    </div>
  );
};

export default InsightsDashboard;
